/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */

import { css, html, LitElement } from 'lit-element';

/**
 * @prop {String} alignment - Defines whether the alignment of the text. Accepted values are right or left.
 * @slot -unnamed slot takes plain text as a child element.
 */

export class SHImageText extends LitElement {
  static get properties() {
    return {
      alignment: { type: String, reflect: true },
    };
  }

  render() {
    return html` <slot></slot> `;
  }

  static get styles() {
    return [
      css`
        :host {
          transition: var(--transition-time) all ease-in-out;
          width: 100%;
          font: var(--body-1);
          line-height: 1.25rem;
          color: var(--text-white);
          text-shadow: 0.0625rem 0.0625rem 0.25rem black, -0.0625rem -0.0625rem 0.25rem black,
            0rem 0rem 0.25rem black, 0rem 0rem 0.125rem black;
          word-wrap: break-word;
        }
        :host([alignment='left']) {
          text-align: left;
        }
        :host([alignment='right']) {
          text-align: right;
        }
      `,
    ];
  }
}

customElements.define('sh-image-text', SHImageText);
